<template>
  <b-modal
    :id="modalId"
    cancel-variant="outline-secondary"
    :ok-title="ok_title"
    :cancel-title="$t('generals.cancel')"
    centered
    :title="modal_title"
    size="lg"
    no-close-on-backdrop
    @hidden="form_obj = def_form_obj"
    @ok="saveClick"
    @show="modalOpened"
  >
    <validation-observer ref="simpleRules">
      <b-form @submit.prevent="saveClick">
        <b-row>
          <b-col
            v-for="(field, index) in form_fields"
            :key="index"
            :cols="field.col_size || 12"
          >
            <b-form-group>
              <label class="d-block" :for="`field-${index}`">{{
                field.label || " "
              }}</label>
              <validation-provider
                #default="{ errors }"
                :name="field.label"
                :rules="field.validation_rules"
              >
                <component
                  :is="field.component_name || 'b-form-input'"
                  :id="`field-${index}`"
                  v-model.trim="form_obj[field.obj_name]"
                  v-bind="field.props"
                  :switch="field.switch"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="field.placeholder"
                  @input="$emit('form_update', form_obj)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal,
  BForm,
  BFormGroup,
  BFormCheckbox,
  BFormInput,
  BRow,
  BCol,
  BFormRadioGroup,
  BFormFile,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import vSelect from "vue-select";
// import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import flatPickr from "vue-flatpickr-component";
import Cleave from "vue-cleave-component";
import datePicker from "@/components/datePicker.vue";

export default {
  components: {
    BModal,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BRow,
    BCol,
    flatPickr,
    BFormRadioGroup,
    Cleave,
    BFormFile,
    datePicker,
  },
  props: {
    form_fields: {
      type: Array,
      required: true,
    },
    modal_title: {
      type: String,
      required: true,
    },
    def_form_obj: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    modalId: {
      type: String,
      required: false,
      default: "validated-form-modal",
    },
    ok_title: {
      type: String,
      required: false,
      default: "Сохранить",
    },
  },
  data() {
    return {
      required,
      form_obj: {},
    };
  },
  watch: {
    def_form_obj() {
      this.form_obj = this.def_form_obj;
    },
  },
  mounted() {
    if (this.def_form_obj) {
      this.form_obj = this.def_form_obj;
    }
  },
  methods: {
    saveClick(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.$emit("formSubmit", this.form_obj);
        }
      });
    },
    modalOpened() {
      this.$nextTick(() => {
        // this.$refs.simpleRules.reset()
        // console.log(this.$refs.simpleRules)
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
